/* eslint-disable */
import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import type { ProductTimelineItem } from '../../types/productDashboard';
import { SRTableRow } from './SRTableRow';

interface SRGroupProps {
  groupKey: string;
  groupLabel: string;
  items: ProductTimelineItem[];
  isExpanded: boolean;
  onToggle: () => void;
}

export const SRGroup: React.FC<SRGroupProps> = ({
  groupLabel,
  items,
  isExpanded,
  onToggle,
}) => {
  const srCount = items.length;
  const srText = srCount === 1 ? 'SR' : 'SRs';

  return (
    <Box data-testid="sr-group" sx={{ mb: 2.5, scrollMarginTop: '180px' }}>
      {/* Group Header */}
      <Box
        data-testid="sr-group-header"
        onClick={onToggle}
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: 2.5,
          backgroundColor: 'grey.100',
          borderRadius: 1,
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: 'grey.200',
          },
          transition: 'background-color 0.2s',
        }}
      >
        <IconButton
          size="small"
          sx={{ mr: 1 }}
          aria-label={isExpanded ? 'Collapse group' : 'Expand group'}
        >
          {isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
        </IconButton>
        <Typography variant="h6" sx={{ fontWeight: 'bold', flexGrow: 1 }}>
          {groupLabel}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ({srCount} {srText})
        </Typography>
      </Box>

      {/* Collapsible Content */}
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <Box sx={{ mt: 2.5 }}>
          <TableContainer component={Paper} elevation={1} sx={{ overflow: 'hidden' }}>
            <Table sx={{ minWidth: 650 }} aria-label={`${groupLabel} SR table`}>
              <TableHead>
                <TableRow sx={{ backgroundColor: 'grey.50' }}>
                  <TableCell sx={{ width: '40px', px: 1.5, py: 1.5 }} />
                  <TableCell sx={{ fontWeight: 'bold', width: '120px', px: 1.5, py: 1.5 }}>
                    SR Key
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', px: 1.5, py: 1.5 }}>Title</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '120px', px: 1.5, py: 1.5 }}>
                    Status
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '150px', px: 1.5, py: 1.5 }}>
                    Expected Version
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '140px', px: 1.5, py: 1.5 }}>
                    Delivery Status
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '200px', px: 1.5, py: 1.5 }}>
                    Progress
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((item) => (
                  <SRTableRow key={item.sr_key} item={item} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Collapse>
    </Box>
  );
};
